<fieldset>
	<legend class="c-form__label c-text c-text--center" [ngClass]="{'c-form__label--disabled': vm.isDisabled}" *ngIf="vm.label">{{ vm.label }}</legend>
	<div class="c-pills" [ngClass]="{'c-pills--disabled': vm.isDisabled}">
		<label class="c-pills__tab" *ngFor="let tab of vm.tabs ; let $index=index">
			<input type="radio" id="{{vm.id}}{{$index + 1}}" name="{{vm.name}}" (change)="onSelectionChange($event)" value="{{tab.id}}" [required]="vm.isRequired" [disabled]="vm.isDisabled">
			<span id="{{vm.id}}{{$index + 1}}Label">{{ tab.name }}</span>
		</label>
	</div>
</fieldset>
